import React from 'react';
import { Box, Modal, Card, CardContent, Button, Portal, Typography, TextField, Stack } from '@mui/material';
import { ColorPicker } from '../../../../components/ColorPicker';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

export default function NoteModal ({ open, handleSubmit, handleClose }) {
  const [content, setContent] = React.useState('');
  const [selectedColor, setSelectedColor] = React.useState('#ffffff'); // Domyślny kolor

  const handleChange = e => setContent(e.target.value);

  const handleColorChange = color => {
    const newColor = `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, 0.5)`;
    setSelectedColor(newColor);
  };

  return (
    <Portal>
      <Modal open={open} onClose={handleClose} id="block-modal">
        <Card sx={{ ...style, width: '500px' }}>
          <CardContent>
            <Typography variant="body1" textAlign="center">
              Dodaj notatkę
            </Typography>
            <Box height={20} />
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={2} mt={2}>
              <Typography variant="subtitle2" flex="1 1 30%">Kolor notatki</Typography>
              <ColorPicker color={selectedColor} handleColorChange={handleColorChange} width="100%" />
            </Stack>
            <Box height={20} />
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={2} mt={2}>
              <Typography variant="subtitle2" flex="1 1 30%">Treść notatki</Typography>
              <TextField
                label="treść notatki..."
                fullWidth
                size="small"
                value={content}
                onChange={handleChange}
              />
            </Stack>
            <Box height={20} />
            <Button variant="contained" onClick={() => handleSubmit(content, selectedColor)}>Zapisz</Button>
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
};
